import { Dialog, DialogActions, DialogContent, Grid } from "@mui/material";
import { MprcDialogTitleClose, MprcRequestIndicator } from "components";
import { ButtonCancel, ButtonJoin } from "components/buttons";
import { AutoCompleteHierarchicalModel } from "components/MprcAutoCompleteHierarchical";
import { MprcRequestErrorDialog } from "components/MprcRequestErrorDialog";
import RequestErrorUtils from "components/MprcRequestErrorReport";
import { useSnackbar } from "notistack";
import { useCoreApi } from "providers/CoreApiProvider";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { TopicAutoCompleteHierarchical } from "../../components/TopicAutoCompleteHierarchical";

////////////////////////////////////////////////////////////////////////////////

interface IPros {
    topicId: string;
    name: string;
    onClose: (topicDestinyId?: string) => void;
}

/////////////////////////////////////////////////////////////////////////////////

export const JoinTopics: React.FC<IPros> = (props) => {

    const { topicId, name, onClose } = props;
    const api = useCoreApi();
    const { t } = useTranslation();

    const [saving, setSaving] = useState<boolean>(false);
    const [selectTopic, setSelectTopic] = useState<AutoCompleteHierarchicalModel[]>([]);
    const [viewError, setViewError] = useState<any>();
    const { enqueueSnackbar } = useSnackbar();


    ////////////////////////////////////////////////////////////////////////////
    /// EFFECT's
    ////////////////////////////////////////////////////////////////////////////

    useEffect(() => {
        async function postData() {
            try {
                var result = await api.v1.topicManagement.joinTopic({
                    topicDestinyId: selectTopic[0].key,
                    topicSourceId: topicId
                });

                if (result) onClose(selectTopic[0].key);
            }
            catch (e) {
                const errorMessage = RequestErrorUtils.findValidationMessage(e, "", "JoinMembersStaticGroupCircularReference");
                if (errorMessage) enqueueSnackbar(errorMessage, { variant: "error" });
                else setViewError(e);
            }
            setSaving(false);
        }

        if (saving) postData();

    }, [saving]);


    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <>
            <MprcRequestIndicator
                visible={saving}
            />

            <MprcRequestErrorDialog
                error={viewError}
                onClose={() => setViewError(undefined)}
            />

            <Dialog
                open
                fullWidth
                maxWidth="sm"
                onClose={() => onClose()}
            >
                <MprcDialogTitleClose
                    title={t("Topic.List.JoinTopicTitle")}
                    subtitle={name}
                    onClose={() => onClose()}
                />

                <DialogContent>
                    <Grid container rowSpacing={2}>
                        <TopicAutoCompleteHierarchical
                            exceptTopicIds={[topicId]}
                            selectedMode="free"
                            multiSelect={false}
                            selectedItems={selectTopic}
                            onChange={(items) => setSelectTopic(items)}
                            onError={error => setViewError(error)}
                            placeholder={t("Topic.List.JoinTopicPlaceholder")}
                        />
                    </Grid>
                </DialogContent>

                <DialogActions>
                    <Grid container rowSpacing={2} mt={1} ml={2}>
                        <Grid container alignItems="center" spacing={2}>
                            <Grid size="grow">
                                <Grid container justifyContent="end" alignItems="center" spacing={1} mt={1}>
                                    <Grid>
                                        <ButtonCancel onClick={() => onClose()} variant="contained" />
                                    </Grid>
                                    <Grid>
                                        <ButtonJoin
                                            disabled={selectTopic.length == 0 || selectTopic[0].key == topicId}
                                            onClick={() => setSaving(true)}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </>
    );
};
